import { httpClient } from "@/app/client/httpClient";
import { SnapshotCorporation } from "@/types/withholding/SnapshotCorporation";

class WithholdingService {
  async fetchYears(username: string) {
    return await httpClient.withholdings.worker.slips.years.$get({
      query: { username }
    });
  }

  async fetchSlipList(
    year: number,
    username: string
  ): Promise<SnapshotCorporation[]> {
    return await httpClient.withholdings.worker.slips.slips.$get({
      query: { year, username }
    });
  }
}

export const withholdingService = new WithholdingService();
